/**
 * 기능 슬라이스 등록 지점 — features/<name> 스펙을 모은다.
 * (블록/확장을 한 폴더씩 이전하며 추가. 미이전 기능은 기존 배선과 공존)
 */
import { buildRegistry } from "./registry.js";
import pageBreak from "./page-break/index.js";
import image from "./image/index.js";
import video from "./video/index.js";
import audio from "./audio/index.js";
import file from "./file/index.js";
import codeBlock from "./code-block/index.js";
import bookmark from "./bookmark/index.js";

export const FEATURES = [pageBreak, image, file, video, audio, codeBlock, bookmark];
export const registry = buildRegistry(FEATURES);
